// extracted by mini-css-extract-plugin
export default {"customTable":"system_customTable__WiqPb"};